export default "__VITE_ASSET__CAzNyXdH__"